import { Info } from "lucide-react"

import { classNames } from "../../../../lib/classNames"
import { Icon, IconSizes } from "../../../Icon"
import {
  FloatingTooltip,
  FloatingTooltipProps,
} from "../../overlay/FloatingTooltip"

interface InfoTooltipProps extends Omit<FloatingTooltipProps, "trigger"> {
  infoIconClassName?: string
}

export function InfoTooltip({ infoIconClassName, ...props }: InfoTooltipProps) {
  const { content } = props
  if (!content) {
    return null
  }

  const trigger = (
    <Icon
      icon={Info}
      size={IconSizes.ExtraSmall}
      data-testid="info-icon"
      className={classNames("text-v2-foreground-primary", infoIconClassName)}
    />
  )

  return <FloatingTooltip {...props} trigger={trigger} />
}
